import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'white',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    boxShadow: 'md',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
  },
  accordionButton: {
    pl: '3',
    pr: '2',
    bgGradient: 'linear(to-b, alpha.500, alpha.600)',
    borderBottomWidth: '1px',
    borderBottomColor: 'delta.300',
    _hover: {
      bg: 'blackAlpha.400',
    },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
    color: 'white',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  accordionIcon: {
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
    bg: 'alpha.800',
    color: 'white',
    fontWeight: 'medium',
    _last: {
      border: 'none',
    },
  },
};
